module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showSection) ? _c('b-card', {
    staticClass: "mt-3"
  }, [_c('b-card-header', [_c('h5', {
    staticClass: "mb-0"
  }, [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v(_vm._s(_vm.sectionTitle))]), _vm._v(" "), (_vm.summary) ? _c('b-badge', {
    staticClass: "ml-2",
    attrs: {
      "variant": "secondary"
    }
  }, [_vm._v("\n          Total: " + _vm._s(_vm.summary.totalRecords) + " (Old: " + _vm._s(_vm.oldCount) + ", New: " + _vm._s(_vm.newCount) + ")\n        ")]) : _vm._e()], 1)]), _vm._v(" "), _c('b-card-body', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 50
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.hasData) ? _c('div', [(_vm.oldRecords.length > 0) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('h6', {
    staticClass: "mb-2"
  }, [_c('b-badge', {
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v("Old " + _vm._s(_vm.typeLabel) + " (" + _vm._s(_vm.oldRecords.length) + ")")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('b-table', {
    staticClass: "table-sm",
    attrs: {
      "items": _vm.oldRecords,
      "fields": _vm.oldFields,
      "striped": "",
      "hover": "",
      "small": "",
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "documentLink",
      fn: function(row) {
        return _vm.isExpense ? [(row.item.fullDocumentPath) ? _c('div', {
          staticClass: "d-flex align-items-center flex-wrap"
        }, _vm._l((_vm.getDocumentLinks(row.item.fullDocumentPath)), function(link, idx) {
          return _c('a', {
            key: idx,
            staticClass: "btn btn-xs btn-outline-primary mr-1 mb-1",
            attrs: {
              "href": "javascript:void(0)",
              "title": ("View Document " + (idx + 1))
            },
            on: {
              "click": function($event) {
                _vm.openSignedDocument(_vm.getFormattedDocUrl(link))
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-eye mr-1"
          }), _vm._v("View " + _vm._s(idx > 0 ? idx + 1 : '') + "\n                  ")])
        })) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("-")])] : undefined
      }
    }, {
      key: "ledger",
      fn: function(row) {
        return !_vm.isExpense ? [_vm._v("\n                " + _vm._s(row.item.ledger || '-') + "\n              ")] : undefined
      }
    }, {
      key: "amount",
      fn: function(row) {
        return [_vm._v("\n                " + _vm._s(_vm.formatNumber(row.item.amount)) + "\n              ")]
      }
    }, {
      key: "selling_amt",
      fn: function(row) {
        return [_vm._v("\n                " + _vm._s(_vm.formatNumber(row.item.selling_amt)) + "\n              ")]
      }
    }, {
      key: "createdBy",
      fn: function(row) {
        return [_c('div', [_c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(row.item.createdBy || '-'))]), _vm._v(" "), (row.item.createdByEmail) ? _c('br') : _vm._e(), _vm._v(" "), (row.item.createdByEmail) ? _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(row.item.createdByEmail))]) : _vm._e()])]
      }
    }, {
      key: "date",
      fn: function(row) {
        return [_vm._v("\n                " + _vm._s(_vm.formatDate(row.item.loginTime || row.item.docAddedDate || row.item.docRecDate)) + "\n              ")]
      }
    }, {
      key: "docAddedDate",
      fn: function(row) {
        return _vm.isExpense ? [_vm._v("\n                " + _vm._s(_vm.formatDate(row.item.docAddedDate || row.item.docRecDate)) + "\n              ")] : undefined
      }
    }])
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.newRecords.length > 0) ? _c('div', [_c('h6', {
    staticClass: "mb-2"
  }, [_c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("New " + _vm._s(_vm.typeLabel) + " (" + _vm._s(_vm.newRecords.length) + ")")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('b-table', {
    staticClass: "table-sm",
    attrs: {
      "items": _vm.newRecords,
      "fields": _vm.newFields,
      "striped": "",
      "hover": "",
      "small": "",
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "documentLink",
      fn: function(row) {
        return _vm.isExpense ? [(row.item.inv_doc_url) ? _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('a', {
          staticClass: "btn btn-xs btn-outline-primary mr-1",
          attrs: {
            "href": "javascript:void(0)",
            "title": "View Document"
          },
          on: {
            "click": function($event) {
              _vm.openSignedDocument(_vm.getFormattedDocUrl(row.item.inv_doc_url))
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-eye mr-1"
        }), _vm._v("View\n                  ")])]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("-")])] : undefined
      }
    }, {
      key: "ledger",
      fn: function(row) {
        return !_vm.isExpense ? [_vm._v("\n                " + _vm._s(_vm.getLedgerName(row.item) || '-') + "\n              ")] : undefined
      }
    }, {
      key: "amount",
      fn: function(row) {
        return [_vm._v("\n                " + _vm._s(_vm.formatNumber(row.item.inv_amt || row.item.amount)) + "\n              ")]
      }
    }, {
      key: "selling_amt",
      fn: function(row) {
        return [_vm._v("\n                " + _vm._s(_vm.formatNumber(row.item.selling_amt)) + "\n              ")]
      }
    }, {
      key: "nature_of_expense",
      fn: function(row) {
        return _vm.isExpense ? [_vm._v("\n                " + _vm._s(_vm.getNatureOfExpense(row.item) || '-') + "\n              ")] : undefined
      }
    }, {
      key: "createdBy",
      fn: function(row) {
        return [_c('div', [_c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(_vm.getCreatedBy(row.item) || '-'))]), _vm._v(" "), (_vm.getCreatedByEmail(row.item)) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.getCreatedByEmail(row.item)) ? _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(_vm.getCreatedByEmail(row.item)))]) : _vm._e()])]
      }
    }, {
      key: "date",
      fn: function(row) {
        return [_vm._v("\n                " + _vm._s(_vm.formatDate(row.item.inv_date || row.item.ape_created_at)) + "\n              ")]
      }
    }])
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && !_vm.hasData) ? _c('div', {
    staticClass: "text-center text-muted py-4"
  }, [_c('p', [_vm._v("No " + _vm._s(_vm.typeLabel.toLowerCase()) + " records found.")])]) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4a5b424","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/components/OldExpenseAdditionalTask.vue
// module id = 2892
// module chunks = 0